import {
  NotificationPermissionResolutionPayload,
  TrackingPermissionSource,
} from '../types/Tracking/types';

export type NotificationPermissionEventType = 'permission-flow-resolved';

export type NotificationPermissionCallback = (
  payload: NotificationPermissionResolutionPayload,
) => void;

class NotificationPermissionEventEmitter {
  private listeners: Map<NotificationPermissionEventType, Set<NotificationPermissionCallback>> =
    new Map();

  on(event: NotificationPermissionEventType, callback: NotificationPermissionCallback): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }

    this.listeners.get(event)!.add(callback);

    return () => {
      this.listeners.get(event)?.delete(callback);
    };
  }

  emit(event: NotificationPermissionEventType, payload: NotificationPermissionResolutionPayload): void {
    this.listeners.get(event)?.forEach((callback) => {
      try {
        callback(payload);
      } catch (error) {
        console.error(`[NotificationPermissionEvents] Error in listener for "${event}"`, error);
      }
    });
  }

  off(event: NotificationPermissionEventType, callback: NotificationPermissionCallback): void {
    this.listeners.get(event)?.delete(callback);
  }
}

export const notificationPermissionEvents = new NotificationPermissionEventEmitter();

export const NOTIFICATION_PERMISSION_EVENTS = {
  FLOW_RESOLVED: 'permission-flow-resolved' as NotificationPermissionEventType,
};

export const buildNotificationPermissionResolutionPayload = (
  status: NotificationPermissionResolutionPayload['status'],
  source: TrackingPermissionSource,
  prompted: boolean,
): NotificationPermissionResolutionPayload => ({
  status,
  source,
  prompted,
  resolvedAt: new Date().toISOString(),
});
